import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetInviteFriendCommissionHistoryResponseData } from '@/modules/promotion/type'
import InviteFriendCommissionHistoryTable from '../InviteFriendCommissionHistoryTable'

interface InviteFriendCommissionHistoryListingProps {
	data: GetInviteFriendCommissionHistoryResponseData[]
	total: number
	isLoading?: boolean
}

export default function InviteFriendCommissionHistoryListing({
	data,
	total,
	isLoading,
}: InviteFriendCommissionHistoryListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title="ประวัติคอมมิชชั่นชวนเพื่อน"
					description="แสดงประวัติการได้รับคอมมิชชั่นจากการชวนเพื่อน"
				/>
			</div>
			<Separator />
			<InviteFriendCommissionHistoryTable
				data={data}
				total={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
